import CountryData from "../components/DataToDisplay/CountryData";

const CountryDataPage = ()=>
{
    return(
        <CountryData/>
    );
};

export default CountryDataPage;